import { GetMienCuPhapID } from "../../utils/common";
import { globalDexieDb } from "../DexiedbLib";
import { IMessageDetail } from "../model/messageDetails";
import { FillGiuLaiChung } from "./giuLaiChung";
import { ApiResult } from "./localBackend";

export interface DataCanChuyenStruct {
    daiId1: string;
    daiId2: string;
    loaiCuocId: string;
    soCuoc: string;
    diemThucNhan: number;
    diemDaChuyen: number;
    diemGiu: number;
    kieuGiu: string;
    max: number; // giữ lớn nhất ko quá số này
    min: number; // từ số điểm này trở xuống ăn hết
}

export interface SttStruct {
    loaiCuocId: string;
    stt: number;
}

export interface DataCanChuyenResult {
    dataCanChuyenStruct: DataCanChuyenStruct[];
    foundStt: { [key: string]: SttStruct }; /*['De','Lo','3c'] để biết loại cược nào giữ lại theo điểm của bộ số có stt=n
	mỗi loại cược chỉ xuất hiện 1 lần
	*/
    jsonNgoaiLe: string;

}
//const { userId, daiList, loaiCuocList, date, contactId } = payload
export async function getDataCanChuyenLocal(payload: any): Promise<ApiResult> {
    const { userId, daiList, loaiCuocList, date, contactId } = payload
    const result: DataCanChuyenResult = {
        dataCanChuyenStruct: [],
        foundStt: {},
        jsonNgoaiLe: "",
    }
    const dais = daiList.split(",")
    const loais = loaiCuocList.split(",")
    const response: ApiResult = {
        responseText: "",
        errorCode: 0,
        data: "",
        dataEx: null,

    }
    let msgs;

   
    msgs = await globalDexieDb.dbmessages.where("[date+userId]").equals([date,userId]).toArray()
    const detailsData: IMessageDetail[] = []
    for (let msg of msgs) {
        const details = await globalDexieDb.messageDetails.where("messageId").equals(msg.messageId!)
            .and((item) => {
                const okDai = dais.includes(item.daiId1) || dais.includes(item.daiId2)
                const okLoaiCuoc = loais.includes(item.loaiCuocId)
                return okDai && okLoaiCuoc

            }).toArray()
        detailsData.push(...details)
    }
    // build data can chuyển struct
    const map: Map<string, DataCanChuyenStruct> = new Map();
    for (let detail of detailsData) {
        const data: DataCanChuyenStruct = {
            daiId1: detail.daiId1!,
            daiId2: detail.daiId2!,
            loaiCuocId: detail.loaiCuocId!,
            soCuoc: detail.soCuoc!,
            diemThucNhan: detail.heSoNhan == 1 ? detail.diem! : 0,
            diemDaChuyen: detail.heSoNhan == -1 ? detail.diem! : 0,
            diemGiu: 0,
            kieuGiu: "",
            max: 0!,
            min: 0,
        }

        const key = detail.daiId1 + detail.daiId2 + detail.loaiCuocId + detail.soCuoc;
        let found = map.get(key);
        if (!found) {
            found = data;
            map.set(key, found);
        } else {
            found.diemThucNhan += detail.heSoNhan == 1 ? detail.diem! : 0
            found.diemDaChuyen += detail.heSoNhan == -1 ? detail.diem! : 0
        }
    }
    // add từ map vào kết quả
    const mienCuPhapId = GetMienCuPhapID()
    for (let [key, value] of map) {
        await FillGiuLaiChung(contactId, mienCuPhapId, value, result)
        result.dataCanChuyenStruct.push(value);
    }
    response.data = result;
    const jsonNgoaiLe = await globalDexieDb.ngoaiLe.get(contactId)
    if (jsonNgoaiLe) {
        result.jsonNgoaiLe = jsonNgoaiLe.json;
    }
    return response;
}